import React from 'react';
import { Navigate } from 'react-router';
import { usePermissions } from "src/contexts/permissions";
import useAuth from 'src/hooks/useAuth';

const CanGuard = (canRules) => ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { can } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const canAccess = canRules.every(rule => can(rule))

  if (!canAccess) {
    return <Navigate to="/403" replace />;
  }

  return (
    <>
      {children}
    </>
  );
};

export default CanGuard
